import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { internalLayersKeys } from './queryKeys';
import { buildSearchQueryParams } from 'hooks/shared/buildSearchQueryParams';
import type {
  InternalLayer,
  ListInternalLayersFilter,
  ListInternalLayersQuery,
  ListLayersResponse,
} from './types';

export const useListInternalLayersQuery = (query: ListInternalLayersQuery) => {
  return useQuery({
    queryKey: internalLayersKeys.list(query),
    queryFn: async () => {
      const searchParams =
        buildSearchQueryParams<ListInternalLayersFilter>(query);

      try {
        const resp = await axios.get<ListLayersResponse<InternalLayer>>(
          config.apiGateway.internal_layers,
          {
            params: {
              ...searchParams,
              // API needs to be updated to "perPage"
              per_page: searchParams.perPage,
              include: 'incident',
            },
          }
        );
        // #region agent log
        fetch(
          'http://127.0.0.1:7250/ingest/d34173ea-f10f-4b43-b38f-5b4d5b60606c',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Debug-Session-Id': '30a1ee',
            },
            body: JSON.stringify({
              sessionId: '30a1ee',
              hypothesisId: 'B',
              location: 'useListInternalLayersQuery.ts:queryFn',
              message: 'internal layers list ok',
              data: {
                status: resp.status,
                count: resp.data?.data?.length ?? null,
              },
              timestamp: Date.now(),
            }),
          }
        ).catch(() => {});
        // #endregion
        return resp.data;
      } catch (error) {
        const response = (
          error as { response?: { status?: number; data?: { error?: unknown; message?: unknown } } }
        ).response;
        // #region agent log
        fetch(
          'http://127.0.0.1:7250/ingest/d34173ea-f10f-4b43-b38f-5b4d5b60606c',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Debug-Session-Id': '30a1ee',
            },
            body: JSON.stringify({
              sessionId: '30a1ee',
              hypothesisId: 'B',
              location: 'useListInternalLayersQuery.ts:queryFn',
              message: 'internal layers list failed',
              data: {
                status: response?.status ?? null,
                serverError:
                  typeof response?.data?.error === 'string'
                    ? response.data.error.slice(0, 300)
                    : typeof response?.data?.message === 'string'
                      ? response.data.message.slice(0, 300)
                      : null,
              },
              timestamp: Date.now(),
            }),
          }
        ).catch(() => {});
        // #endregion
        throw error;
      }
    },
  });
};
